import React  from 'react'
import {compose, setDisplayName, withHandlers, withPropsOnChange } from "recompose";
import { ifElse, always, equals } from "ramda";
import {connect} from "react-redux";

import { nextDropdown } from '../../../../../../actions/dropdown'
import { DropdownMenu } from "../../../../../Shared/DropdownMenu/DropdownMenu";

import './Bookmarks.css'
import { getLocaleString } from "../../../../../../locale";
import { Scrollbars } from "react-custom-scrollbars";
import { formatDate, getBookmarkPage } from "../../../../../../utilities/utilities";

const DROPDOWN_ID = 'BOOKMARKS'
const isActive = equals(DROPDOWN_ID)

const toggleMenu = ({activeDropdown, nextDropdown}) => ({isInner = false}) => ifElse(
  equals(true),
  () => nextDropdown(null),
  () => ifElse(
    equals(false),
    () => nextDropdown(DROPDOWN_ID),
    always(null)
  )(isInner)
)(isActive(activeDropdown))

const mapStateToProps = state => ({
  activeDropdown: state.activeDropdown,
  bookmarks: state.reader.bookmarks
})

const mapDispatchToProps = (dispatch) => ({
  nextDropdown: (id) => dispatch(nextDropdown(id)),
})

const handlers = withHandlers({
  toggleMenu
})

export const enhance = compose(
  setDisplayName('Bookmarks'),
  connect(mapStateToProps, mapDispatchToProps),
  withPropsOnChange(['activeDropdown'], ({activeDropdown}) => ({
    active: isActive(activeDropdown)
  })),
  handlers
)

const BookmarkList = ({bookmarks, toggleMenu, onLoadBookMark, onDeleteNote, rendition}) => (
  <ul className="bookmarks">
    {bookmarks.length > 0 ? bookmarks.sort((a,b) => {
      if (a.mark && b.mark) {
        if (a.mark.created && b.mark.created) {
          if (a.mark.created < b.mark.created)
            return 1;
          if (a.mark.created > b.mark.created)
            return -1;
        } else {
          if (a.mark.updated < b.mark.updated)
            return 1;
          if (a.mark.updated > b.mark.updated)
            return -1;
        }
      }
      return 0;
    }).map((bookmark, index) =>
      <BookmarkItem key={index} bookmark={bookmark} toggleMenu={toggleMenu} onLoadBookMark={onLoadBookMark}
                    onDeleteNote={onDeleteNote} rendition={rendition}/>
    ) : ''}
  </ul>
)

const BookmarkItem = ({bookmark, toggleMenu, onLoadBookMark, onDeleteNote, rendition}) => {
  if (!bookmark.mark.anchor) return ''
  let page = getBookmarkPage(rendition, bookmark)
  if (!bookmark.mark.created || !page) return ''

  return <li className="bookmark-item" onClick={() => {
    toggleMenu(false);
    onLoadBookMark(bookmark.mark.anchor)
  }}>
    <span className="bookmark-item-text">{bookmark.mark.created ? formatDate(bookmark.mark.created, true) : ''}</span>
    <span className="bookmark-item-page">{page}</span>
    <button className="bookmark-delete icon-btn" onClick={(e) => {
      e.stopPropagation();
      onDeleteNote(bookmark)
    }}></button>
  </li>
}

const View = ({toggleMenu, active, bookmarks, onLoadBookMark, onDeleteNote, rendition}) => (
  <div className="Bookmarks__wrap">
    <button className="bookmarks-btn icon-btn" onClick={toggleMenu} data-active={active}></button>
    <DropdownMenu active={active}>
      <div className="Bookmarks__header Dropdown__header">
        <span className="Bookmarks__header-text">{getLocaleString('reader.bookmarksTitle')}</span>
        <button className="btn btn-close-white icon-btn" onClick={toggleMenu} data-active={active}></button>
      </div>
      <div className="Bookmarks__content limit-content-height">
        <Scrollbars style={{ width: 315, height: 432 }}>
          <BookmarkList bookmarks={bookmarks} toggleMenu={toggleMenu} onLoadBookMark={onLoadBookMark}
                      onDeleteNote={onDeleteNote} rendition={rendition} />
        </Scrollbars>
      </div>
    </DropdownMenu>
  </div>
)

export const Bookmarks = enhance(View)


// WEBPACK FOOTER //
// ./src/components/Reader/components/Navigation/components/Bookmarks/Bookmarks.js